import { CURATED_SHELVES } from "../../data/shelvesContent";
import ShelfCard from "../ShelfCard";
import SectionViewAllLink from "./SectionViewAllLink";

const HomeShelvesSection = ({ Reveal }) => (
  <section
    id="shelves"
    data-testid="shelves-section"
    className="relative py-28 md:py-36 scroll-mt-28"
    style={{ background: "var(--bg)" }}
  >
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span
              className="inline-block text-[11px] uppercase tracking-[0.25em] font-semibold mb-4"
              style={{ color: "var(--brand)" }}
            >
              Discover New Realms
            </span>
            <h2
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05]"
              style={{ color: "var(--text)" }}
            >
              Immerse yourself in{" "}
              <span className="italic" style={{ color: "var(--brand)" }}>
                curated shelves
              </span>
            </h2>
            <p
              className="mt-5 text-lg max-w-xl"
              style={{ color: "var(--text-soft)" }}
            >
              We gather collections, member shelves, and weekend reads so your
              next favorite story is always one bookmark away.
            </p>
          </div>
          <SectionViewAllLink
            to="/shelves"
            label="See all shelves"
            testId="see-books-btn"
            className="hidden md:inline-flex shrink-0"
          />
        </div>
      </Reveal>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {CURATED_SHELVES.map((shelf, i) => (
          <Reveal key={shelf.slug} delay={i * 0.06}>
            <ShelfCard shelf={shelf} testId={`shelf-card-${i}`} />
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-10 md:hidden">
        <SectionViewAllLink
          to="/shelves"
          label="See all shelves"
          testId="see-books-btn-mobile"
          className="w-full justify-center"
        />
      </Reveal>
    </div>
  </section>
);

export default HomeShelvesSection;
